"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importStar(require("react"));
const classnames_1 = __importDefault(require("classnames"));
const Tooltip_1 = __importDefault(require("../../components/Tooltip/Tooltip"));
const useIsOverflowing_1 = __importDefault(require("../../hooks/useIsOverflowing"));
const useStyle_1 = __importDefault(require("../../hooks/useStyle"));
const useRefWithCallback_1 = __importDefault(require("../../hooks/useRefWithCallback"));
const TextWithHighlight_1 = __importDefault(require("../TextWithHighlight/TextWithHighlight"));
const HeadingConstants_1 = require("./HeadingConstants");
require("./Heading.scss");
const Heading = ({ className, value = "", type = HeadingConstants_1.HeadingTypes.h1, size = HeadingConstants_1.HeadingSizes.LARGE, ariaLabel = "", id, customColor, ellipsis = true, ellipsisMaxLines = 1, style, tooltipPosition, highlightTerm = null, suggestEditOnHover = false, brandFont = false, nonEllipsisTooltip = null }) => {
    const [componentRef, setRef] = (0, useRefWithCallback_1.default)(node => node.style.setProperty("--heading-clamp-lines", ellipsisMaxLines.toString()));
    const finalStyle = (0, useStyle_1.default)(style, { color: customColor });
    const classNames = (0, classnames_1.default)("heading-component", className, `element-type-${type}`, `size-${size}`, {
        "multi-line-ellipsis": ellipsis && ellipsisMaxLines > 1,
        "single-line-ellipsis": ellipsis && ellipsisMaxLines <= 1,
        "suggest-edit-on-hover": suggestEditOnHover,
        "brand-font": type === HeadingConstants_1.HeadingTypes.h1 && brandFont
    });
    const Element = react_1.default.createElement(type, { className: classNames, "aria-label": ariaLabel, id, ref: setRef, style: finalStyle }, highlightTerm ? ((0, jsx_runtime_1.jsx)(TextWithHighlight_1.default, { highlightTerm: highlightTerm, text: value, linesToClamp: ellipsisMaxLines, useEllipsis: ellipsis, nonEllipsisTooltip: nonEllipsisTooltip, tooltipPosition: tooltipPosition })) : (value));
    const isOverflowing = (0, useIsOverflowing_1.default)({ ref: ellipsis ? componentRef : null });
    (0, react_1.useLayoutEffect)(() => {
        if (componentRef.current) {
            componentRef.current.style.setProperty("--heading-clamp-lines", ellipsisMaxLines === null || ellipsisMaxLines === void 0 ? void 0 : ellipsisMaxLines.toString());
        }
    }, [componentRef, ellipsisMaxLines, isOverflowing]);
    // When using highlight term - use tooltip there
    if (!highlightTerm) {
        if (isOverflowing || nonEllipsisTooltip) {
            const tooltipContent = isOverflowing ? value : nonEllipsisTooltip;
            return ((0, jsx_runtime_1.jsx)(Tooltip_1.default, Object.assign({ content: tooltipContent, position: tooltipPosition }, { children: Element })));
        }
    }
    return Element;
};
Object.assign(Heading, {
    types: HeadingConstants_1.HeadingTypes,
    sizes: HeadingConstants_1.HeadingSizes
});
exports.default = Heading;
